import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SolicitudPasajeroDTO } from 'src/app/infraestructure/interfaces/referente/SolicitudPasajeroDTO';
import {InputValidator} from 'src/app/infraestructure/utils/InputValidator';

@Component({
  selector: 'app-table-officials',
  templateUrl: './table-officials.component.html',
  styleUrls: ['./table-officials.component.scss']
})
export class TableOfficialsComponent implements OnInit {

  @ViewChild('modalRegister', { static: true }) modalRegister: any;

  @Output() $pasajerosChange = new EventEmitter<any>();

  @Input() $pasajeros: any;

  @Input() $viewButton: boolean = false;


  solicitudPasajero: SolicitudPasajeroDTO = new SolicitudPasajeroDTO();


  constructor(
    private _modalService: NgbModal,
  ) { }

  ngOnInit(): void {
  }


  openModal() {
    this._modalService.open(this.modalRegister, { size: 'xl' });
  }

  addRegOfficial() {
    this.$pasajeros.push(this.solicitudPasajero);
    this.solicitudPasajero = new SolicitudPasajeroDTO();
    this._modalService.dismissAll();
  }

  deleteFunct(index: number) {
    this.$pasajeros.splice(index, 1);
  }

  //Función que ajusta el formato de inputs a numericos
  validateFormat(event: any) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
     if (!regex.test(key)) {
      event.returnValue = false;
       if (event.preventDefault) {
        event.preventDefault();
       }
     }
  }

  isLetter(event: KeyboardEvent): boolean {
    return InputValidator.isLetter(event);
  }

  isLetterOrSpace(event: KeyboardEvent): boolean {
    return InputValidator.isLetterOrSpace(event);
  }
  
  isNumber(event: KeyboardEvent): boolean {
    return InputValidator.isNumber(event);
  }
    
}
